Vue.filter("price", function(value, className, onlyInteger) {
    if (!value) return "";
    value = value.toString();
    let priceText = "";
    if (onlyInteger === true) {
        if (value.indexOf(",") > -1) {
            priceText = value.match(/\d(.*)\d/)[0]; // match only integer part of fractional number (eg 28,21 will match only 28)
            const integerPart = priceText.split(",")[0];
            const fractionPart = "," + priceText.split(",")[1];
            value = value
                .replace(integerPart, `<b class="${className}">${integerPart}</b>`)
                .replace(fractionPart, `<b class="${className}-smoll">${fractionPart}</b>`);
        }
    } else {
        if (value.match(/\d(.*)\//)) {
            priceText = value.match(/\d(.*)\//)[0]; // match everything between first digit and '/' on the end
            value = value.replace(priceText, `<b class="${className}">${priceText}</b>`);
        }
    }

    return value;
});